var icons = {
    equals: "'\\e600'",
    ally: "'\\e601'",
    'money-mail': "'\\e602'",
    mail: "'\\e603'",
    paperstack: "'\\e604'",
    'map-locate': "'\\e605'",
    phone: "'\\e606'",
    'transfer-ira': "'\\e609'",
    transfer: "'\\e60a'",
    'ally-a': "'\\e60b'",
    add: "'\\e60c'",
    alert: "'\\e60d'",
    'ally-auto': "'\\e60e'",
    'ally-bank': "'\\e60f'",
    bar: "'\\e610'",
    calendar: "'\\e611'",
    cancel: "'\\e612'",
    check: "'\\e613'",
    doc: "'\\e614'",
    doccheck: "'\\e615'",
    link: "'\\e617'",
    'ally-lly': "'\\e618'",
    lock: "'\\e619'",
    magnify: "'\\e61a'",
    'money-magnify': "'\\e61b'",
    'nav-bottom': "'\\e61c'",
    pause: "'\\e61d'",
    'pause-circle': "'\\e61e'",
    play: "'\\e61f'",
    'play-circle': "'\\e620'",
    question: "'\\e621'",
    settings: "'\\e623'",
    'no-fees': "'\\e624'",
    'mobile-phone': "'\\e625'",
    'line-graph': "'\\e626'",
    'bar-graph': "'\\e627'",
    'auto-renew': "'\\e628'",
    'member-fdic': "'\\e629'",
    donut: "'\\e62a'",
    ribbon: "'\\e62b'",
    burger: "'\\e62c'",
    'no-min': "'\\e62f'",
    'car-front': "'\\e630'",
    'chat-flipped': "'\\e631'",
    chat: "'\\e632'",
    facebook: "'\\e633'",
    'google-plus': "'\\e634'",
    rss: "'\\e635'",
    'twitter-bird': "'\\e636'",
    youtube: "'\\e637'",
    'donut-flipped': "'\\e638'",
    'ribbon-flipped': "'\\e639'",
    'bar-graph-flipped': "'\\e63a'",
    'auto-renew-flipped': "'\\e63b'",
    'paperstack-flipped': "'\\e63c'",
    'phone-flipped': "'\\e63d'",
    'transfer-flipped': "'\\e63f'",
    'link-flipped': "'\\e640'",
    'magnify-flipped': "'\\e641'",
    information: "'\\e642'",
    'linked-in': "'\\e643'",
    laptop: "'\\e644'",
    'customer-care-flipped': "'\\e645'",
    'customer-care': "'\\e646'",
    'money-stack': "'\\e647'",
    'faq-thumbs-up': "'\\e648'",
    'faq-thumbs-down': "'\\e649'",
    star: "'\\e64a'",
    'dollar-log': "'\\e64b'",
    'question-mark': "'\\e64c'",
    list: "'\\e64d'",
    'larrow-solid': "'\\e64e'",
    'rarrow-solid': "'\\e64f'",
    'uarrow-solid': "'\\e650'",
    'darrow-solid': "'\\e651'",
    monitor: "'\\e652'",
    community: "'\\e653'",
    'map-pin': "'\\e654'",
    'equal-housing-lender': "'\\e655'",
    'circle-dollarlog': "'\\e656'",
    'circle-exclaim-unfilled': "'\\e657'",
    'circle-percent': "'\\e658'",
    'circle-questionmark': "'\\e659'",
    'email-outline': "'\\e65a'",
    fax: "'\\e65b'",
    mailbox: "'\\e65c'",
    print: "'\\e65d'",
    share: "'\\e65e'",
    'credit-alert': "'\\e800'",
    'google-plus-square': "'\\e801'",
    iphone: "'\\e803'",
    shield: "'\\e804'",
    'circle-exclaim': "'\\e900'",
    'circle-check': "'\\e901'",
    clock: "'\\e902'",
    'expand-icon': "'\\e903'",
    'trial-deposit-1-bank': "'\\e904'",
    'trial-deposit-2-check': "'\\e905'",
    'trial-deposit-3-ally': "'\\e906'",
    'auto-keys': "'\\e907'",
    carrot: "'\\e908'",
    'line-chart': "'\\e909'",
    'demand-notes': "'\\e90a'",
    x: "'\\e90b'",
    'arrow-point-left': "'\\e90c'",
    'arrow-point-lower-left': "'\\e90d'",
    'arrow-point-right': "'\\e90e'",
    'cash-envelope-outline': "'\\e90f'",
    'circling-arrows-outline': "'\\e910'",
    'home-outline': "'\\e911'",
    'chat-icon': "'\\e912'",
    'google-plus-circle': "'\\e913'",
    'google-plus-plain': "'\\e914'",
    paper: "'\\e915'",
    'play-square': "'\\e916'",
    invest: "'\\e917'",
    compose: "'\\e918'",
    paperless: "'\\e919'",
    reply: "'\\e91a'",
    'flexible-payment': "'\\e91b'",
    trash: "'\\e91c'",
    'paper-clip': "'\\e91d'",
    bell: "'\\e91e'",
    'zelle-logo': "'\\e91f'",
    'circle-check-hollow': "'\\e920'",
    'credit-card': "'\\e921'",
    'bank-pig': "'\\e922'",
    'info-fill': "'\\e923'",
    lightbulb: "'\\e924'",
    dots: "'\\e925'",
    'double-chevron': "'\\e926'",
    'chevron-right': "'\\e927'",
    'chevron-left': "'\\e928'",
    'chat-lines': "'\\e929'",
    'chat-dots': "'\\e92a'",
    'star-outline': "'\\e92b'",
    'question-mark-encircled-24': "'\\e92c'",
    'question-mark-encircled-16': "'\\e92d'",
    'stk-settings': "'\\e92e'",
    'stk-circle-pie-chart': "'\\e92f'",
    'stk-circle-add': "'\\e930'",
    'stk-booster-round-up': "'\\e931'",
    'stk-booster-set-and-forget': "'\\e932'",
    iconFontStyles: "\n      font-family: 'icomoon' !important;\n      speak: none;\n      font-style: normal;\n      font-weight: normal;\n      font-variant: normal;\n      text-transform: none;\n      line-height: 1;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n  ",
};
export default icons;
//# sourceMappingURL=icons.js.map